export const MIN_VOTING_VALUE = 5000000;
export const WEI = 1000000000000000000;
